import React from 'react'
import { Controller, useFormState } from 'react-hook-form'
import { DatePicker } from 'antd'
import styles from './DatePickerField.module.css'
import { ConfigProvider } from 'antd'
import locale from 'antd/locale/fr_FR'
import dayjs from 'dayjs'

const ActiveDatePickerField = ({ field, control, setValue }) => {
  const { errors, isSubmitted } = useFormState({ control })
  const error = errors[field.idFieldCanvas]
  let defaultRange = null

  if (
    field.VALUE__reponse &&
    field.VALUE__reponse !== undefined &&
    field.VALUE__reponse !== 'null'
  ) {
    defaultRange = field.VALUE__reponse
      ? dayjs(field.VALUE__reponse, 'DD-MM-YYYY')
      : null
  }

  const DatePickerRender = ({ onChange = () => {}, value }) => {
    const input_style = field.input_design ? { ...field.input_design } : {}
    let inputClass = ''

    if (isSubmitted) {
      inputClass = error ? 'input-error' : 'input-success'
    }

    return (
      <DatePicker
        className={inputClass}
        style={input_style || {}}
        value={value}
        format="DD-MM-YYYY"
        placeholder={field.placeholder || ''}
        onChange={(date) => {
          onChange(date ? date : null)
        }}
      />
    )
  }

  return (
    <Controller
      control={control}
      name={field.idFieldCanvas}
      rules={{ required: field.required }}
      render={({ field: { onChange, value } }) => (
        <DatePickerRender onChange={onChange} value={value} />
      )}
      defaultValue={defaultRange}
    />
  )
}

// Composant pour le cas isActiveSubmit = false
const InactiveDatePickerField = ({ field }) => {
  const input_style = field.input_design ? { ...field.input_design } : {}
  return (
    <DatePicker
      placeholder={field.placeholder || ''}
      format="DD-MM-YYYY"
      style={input_style || {}}
    />
  )
}

const DatePickerField = ({ field, control, setValue, isActiveSubmit }) => {
  return isActiveSubmit ? (
    <ActiveDatePickerField
      field={field}
      control={control}
      setValue={setValue}
    />
  ) : (
    <InactiveDatePickerField field={field} />
  )
}

export default DatePickerField
